import React from 'react';

const baseStyle = {
  padding: '12px 16px',
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(0, 212, 255, 0.3)',
  borderRadius: 8,
  color: '#fff',
  fontSize: 16,
};

/**
 * Campo de texto do dashboard (borda cyan, fundo escuro). Use `fullWidth` em formulários de largura total; sobrescreva `style` quando precisar do visual de outras telas (ex.: Suporte).
 */
export default function Input({
  fullWidth = true,
  style,
  className,
  disabled,
  ...rest
}) {
  const merged = {
    ...baseStyle,
    ...(fullWidth ? { width: '100%', boxSizing: 'border-box' } : {}),
    ...(disabled ? { opacity: 0.65, cursor: 'not-allowed' } : {}),
    ...style,
  };

  return <input className={className} style={merged} disabled={disabled} {...rest} />;
}
